import * as React from "react";
import moment from 'moment'
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { ColumnConfig, RepeatableSection } from "../components/RepeatableSection";
import { CurrencyModel } from "@/app/models/newDelegation/currencyModel";
import { MinimumWageAllowanceExpandableItemModel } from "@/app/models/configuration/minimumWage/minimumWageAllowanceExpandableItemModel";
import { MinimalCountryAccomodationType } from "@/app/constants/configuration/minimalCountryAccomodationType";
import { getMinimalCountryAccomodationTypeName } from "@/app/common/converters/configuration/minimalCountryAccomodationTypeToTextConverter";

type Props = {
    title?: string
    accomodationTypes?: MinimalCountryAccomodationType[]
    allowedCurrencies?: string[]
    readOnly?: boolean
    state: {
        configuration: { currencies: CurrencyModel[] }
        allowanceExpandableItems: MinimumWageAllowanceExpandableItemModel[]
    }
    setState: React.Dispatch<React.SetStateAction<{ allowanceExpandableItems: MinimumWageAllowanceExpandableItemModel[] }>>
}

export const MinimumWageAllowanceExpandableItemSection = ({ readOnly, title, accomodationTypes, allowedCurrencies, state, setState }: Props) => {
    const { t } = useLocalize()

    return (
        <RepeatableSection<MinimumWageAllowanceExpandableItemModel>
            title={title || t('configuration.minimumWages.minimalAllowanceTitle')}
            newRow={() => ({
                allowanceCurrency: { id: 1, code: "PLN", name: "złoty" },
                allowanceValue: 0,
                configurationValueId: 0,
                dateFrom: moment(),
                isNew: true,
            })}
            readOnly={readOnly}
            columns={[
                {
                    order: 1,
                    label: t('configuration-minimumWage.from-date'),
                    type: "date",
                    readOnly,
                    get: (r) => r.dateFrom,
                    set: (r, v) => ({ ...r, dateFrom: moment(v) }),
                },
                {
                    order: 3,
                    label: t('common.amount'),
                    type: "price",
                    readOnly,
                    get: (r) => r.allowanceValue,
                    set: (r, v: number) => ({ ...r, allowanceValue: Number(v) }),
                },
                {
                    order: 5,
                    label: t("configuration.countries.currency"),
                    type: "select", //"currency",
                    readOnly,
                    options: state.configuration.currencies.filter(c => allowedCurrencies ? allowedCurrencies.includes(c.code) : true).map((c) => ({ label: `${c.code} - ${c.name}`, value: c.code })).sort((a, b) => a.label.localeCompare(b.label)),
                    get: (r) => r.allowanceCurrency.code,
                    set: (r, v) => {
                        const selected = state.configuration.currencies.find(c => c.code === v)
                        return ({ ...r, allowanceCurrency: selected })
                    }
                },
                ...(accomodationTypes ? [{
                    order: 6,
                    label: t('common.type'),
                    type: "select", //"currency",
                    readOnly,
                    options: accomodationTypes.map((value) => ({ value: value.toString(), label: getMinimalCountryAccomodationTypeName(value, t) })),
                    get: (r) => r.allowanceType,
                    set: (r, v) => {
                        const selected = accomodationTypes.find(c => c == v)
                        if(selected){
                            return ({ ...r, allowanceType: selected })
                        }
                        return ({ ...r })
                    }
                } as ColumnConfig<MinimumWageAllowanceExpandableItemModel>] : []),
            ]}
            canAddRow={true}
            rows={state.allowanceExpandableItems}
            setRows={(next) => {
                setState(prev => {
                    const current = prev.allowanceExpandableItems;
                    const nextRows = typeof next === "function" ? (next as (p: typeof current) => typeof current)(current) : next;
                    return { ...prev, allowanceExpandableItems: nextRows };
                });
            }}
            sortRows={(a, b) => {
                const da = moment(a.dateFrom)
                const db = moment(b.dateFrom)
                const ta = da.valueOf()
                const tb = db.valueOf()
                if(ta===tb) return 0
                return ta > tb ? -1 : 1
            }}
        />
    )
}
